import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { formatDateTimeEsCO } from "../../../helpers";
import { useForm } from "../../../hooks";
import { usePatientSurgeryStore } from "../../hooks";
import { useFormEventStore, useFormMessages } from "../../hooks";
import { translationsPatientSurgeryState } from "../../data";
import { TextArea } from "../../ui";

const formValidationInitial = {
  protocol: [(value) => value.length > 0, "El protocolo no puede ser vacio"],
};
export const ModifyProtocolModal = ({ isOpen, setIsOpen, patientSurgery }) => {
  // Datos del hook ----------------------------------------//
  const { message, isLoading } = useFormEventStore();
  const { updatePatientSurgery } = usePatientSurgeryStore();
  // States ------------------------------------------------//
  const { patient, procedure, ...rest } = patientSurgery;
  const { firstName, lastName } = patient.user;
  const { title } = procedure.procedure;

  const [validateForm, setValidateForm] = useState(false);
  const [formData, setFormData] = useState(rest);
  const [formValidations, setFormValidations] = useState(formValidationInitial);
  // Formulario --------------------------------------------//

  const { formState, formValidation, onInputChange, isFormValid } = useForm(
    formData,
    formValidations
  );

  const { setFormSubmitted } = useFormMessages({
    message,
    setValidateForm,
  });
  // Funciones ---------------------------------------------//
  const handleSubmit = (e) => {
    e.preventDefault();
    setValidateForm(true);
    if (isFormValid) {
      setFormSubmitted(true);
      updatePatientSurgery(formState);
      setIsOpen(false);
    }
  };
  // Efectos -----------------------------------------------//

  return (
    <Modal show={isOpen} onHide={() => setIsOpen(false)} centered size="md">
      <form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <h5 className="modal-title">Modificar valoración</h5>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex">
            <label className="fw-bold">Nombre:</label>
            <p className="">
              {firstName} {lastName}
            </p>
          </div>
          <div className="d-flex">
            <label className="fw-bold">Procedimiento:</label>
            <p className="">{title}</p>
          </div>
          <div className="d-flex">
            <label className="fw-bold">Fecha:</label>
            <p className="">{formatDateTimeEsCO(formState.createdAt)}</p>
          </div>
          <div className="d-flex">
            <label className="fw-bold">Estado:</label>
            <p className="">
              {translationsPatientSurgeryState[formState.state]}
            </p>
          </div>
          <div className="d-flex">
            <label className="fw-bold">Seguimiento:</label>
            <p className="">{formState.track}</p>
          </div>

          <hr />

          <div className="d-flex">
            <label className="fw-bold">Asa:</label>
            <p className="">{formState.asa}</p>
          </div>

          <div className="d-flex">
            <label className="fw-bold">Escala de fragilidad:</label>
            <p className="">{formState.Cfs}</p>
          </div>

          <div className="d-flex">
            <label className="fw-bold">Mets:</label>
            <p className="">{formState.mets}</p>
          </div>

          <div className="d-flex">
            <label className="fw-bold">Riesgo cardiovascular:</label>
            <p className="">{formState.cRisk}</p>
          </div>

          <label className="fw-bold">Protocolo:</label>
          <TextArea
            name="protocol"
            placeholder="Protocolo"
            submit={validateForm}
            value={formState.protocol}
            validation={formValidation.protocolValid}
            onInputChange={onInputChange}
            rows={6}
          />
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setIsOpen(false)}
          >
            Cerrar
          </button>
          <button type="submit" className="btn btn-primary">
            Guardar
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};
